import { render, staticRenderFns } from "./ClusterStatus.vue?vue&type=template&id=5d350d9a&scoped=true"
import script from "./ClusterStatus.vue?vue&type=script&lang=js"
export * from "./ClusterStatus.vue?vue&type=script&lang=js"
import style0 from "./ClusterStatus.vue?vue&type=style&index=0&id=5d350d9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d350d9a",
  null
  
)

export default component.exports